import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TEmissions from './Tables/TEmissions';
const Emissions: React.FC = () => {
    return (
        <div>
            <AdminHeader>Fuentes de emisión</AdminHeader>
            <TEmissions/>      
        </div>

    );
};
export default Emissions;